import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from '../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()
const metaRef = db.ref('_meta')
const usersListRef = metaRef.child('userslist')
const emailsListRef = metaRef.child('registerableEmails')
const userEmailsListRef = metaRef.child('userEmails')
const versionCheckRef = metaRef.child('versionCheck')
const progressRef = metaRef.child('progress')
const summaryRef = metaRef.child('summary')

export const _metaModule = {
  namespaced: true,
  state: {
    usersList: {},
    emailsList: {},
    userEmailsList: {},
    progress: {},
    summary: {},
    versionCheck: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_META_USERS_LIST]: firebaseAction(({ bindFirebaseRef }) => {
      console.log('GET_META_USERS_LIST:', usersListRef)
      bindFirebaseRef('usersList', usersListRef, { wait: true })
    }),
    [getterConstants.GET_META_EMAILS_LIST]: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('emailsList', emailsListRef, { wait: true })
    }),
    [getterConstants.GET_META_USER_EMAILS_LIST]: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('userEmailsList', userEmailsListRef, { wait: true })
    }),
    [getterConstants.GET_META_PROGRESS]: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('progress', progressRef, { wait: true })
    }),
    [getterConstants.UNBIND_META_PROGRESS]: firebaseAction(({ bindFirebaseRef, unbindFirebaseRef }) => {
      unbindFirebaseRef('progress')
    }),
    [getterConstants.GET_META_SUMMARY]: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('summary', summaryRef, { wait: true })
    }),
    [getterConstants.UNBIND_META_SUMMARY]: firebaseAction(({ bindFirebaseRef, unbindFirebaseRef }) => {
      unbindFirebaseRef('summary')
    }),
    [getterConstants.GET_META_VERSION_CHECK]: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('versionCheck', versionCheckRef, { wait: true })
    })
  },
  getters: {
    getMetaUsersList: (state) => {
      const metaUsersList = state.usersList
      delete metaUsersList['.key']
      return metaUsersList
    },
    getMetaEmailsList: (state) => {
      const metaEmailsList = state.emailsList
      delete metaEmailsList['.key']
      return metaEmailsList
    },
    getMetaDecodeEmailList: (state) => {
      const metaUserEmailsList = state.userEmailsList
      delete metaUserEmailsList['.key']
      let userEmailsList = {}
      Object.keys(metaUserEmailsList).forEach(x => { userEmailsList[decodeURI(x).toLowerCase()] = metaUserEmailsList[x] })
      return userEmailsList
    },
    getMetaIsManager: (state, getters, rootState) => {
      console.log('getMetaIsManager', state)
      let isManager = false
      if (state.usersList[rootState.currentUserId]) {
        isManager = !!state.usersList[rootState.currentUserId].isManager || !!state.usersList[rootState.currentUserId].isAdmin
      }
      console.log('getMetaIsManager', isManager)
      return isManager
    },
    getMetaIsAdmin: (state, getters, rootState) => {
      console.log('getMetaIsAdmin', state)
      let isAdmin = false
      if (state.usersList[rootState.currentUserId]) {
        isAdmin = !!state.usersList[rootState.currentUserId].isAdmin
      }
      console.log('getMetaIsAdmin', isAdmin)
      return isAdmin
    },
    getMetaIsForceBrowsing: (state, getters, rootState) => {
      let isForceBrowsing = false
      if (state.usersList[rootState.currentUserId]) {
        isForceBrowsing = !!state.usersList[rootState.currentUserId].isForceBrowsing
      }
      return isForceBrowsing
    },
    getMetaIsDeveloper: (state, getters, rootState) => {
      console.log('getMetaIsManager', state)
      let isDeveloper = false
      if (state.usersList[rootState.currentUserId]) {
        isDeveloper = !!state.usersList[rootState.currentUserId].isDeveloper
      }
      console.log('getMetaIsDeveloper', isDeveloper)
      return isDeveloper
    },
    getMetaVersionCheck: state => state.versionCheck,
    getMetaProgress: (state) => (userId) => {
      // console.log('getMetaProgress:', userId, state._meta)
      let metaProgress = {}
      if (state.progress) {
        metaProgress = state.progress[userId] || {}
      }
      return metaProgress
    },
    getMetaSummary: (state) => {
      let metaSummary = {}
      if (state.summary) {
        metaSummary = state.summary
      }
      return metaSummary
    },
    getMetaIsDeleted: (state, getters, rootState) => (userId) => {
      let isDeleted = false
      if (state.usersList[userId]) {
        isDeleted = state.usersList[userId].isDeleted
      }
      return isDeleted
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/_meta.js